// Generated by CoffeeScript 2.7.0
var Tag;

import BaseModel from './base_model.js';

export default Tag = (function() {
  class Tag extends BaseModel {
    constructor(attrs = {}) {
      super(attrs);
      if (this.color == null) {
        this.color = _.sample(_cargo.colored_icons.colors);
      }
    }

  };

  Tag.setAttributes(['name', 'color']);

  return Tag;

}).call(this);
